import { atom } from "jotai";
import { atomWithReset } from "jotai/utils";
import { IpomFormSchema } from "components/IpomForm/schema";

export const ipomFormModeAtom = atom<"create" | "preview">("create");
export const ipomFormDataAtom = atomWithReset<Record<string, IpomFormSchema>>(
  {},
);
